import network from '../../utils/network';
import config from '../../config';
import { ACTION_BEGIN, ACTION_FAILURE } from '../app';

export const FETCH_LAST_UPDATE_INFO = 'FETCH_LAST_UPDATE_INFO';

export const fetchLastUpdateInfo = () =>
    network.actionWrapper(
        `${config.getApiUrl()}/last-update-info.json`,
        {
            begin: ACTION_BEGIN,
            success: FETCH_LAST_UPDATE_INFO,
            failure: ACTION_FAILURE,
        });
